import { styles } from './Dependencies.styles';

export const DependenciesLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[112px] animate-pulse rounded bg-grey-25" />
			<div className="h-md w-[128px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex flex-col gap-xs">
				<div className="h-sm w-[128px] animate-pulse rounded bg-grey-25" />
				<div className="h-[28px] w-[200px] animate-pulse rounded bg-grey-25" />
			</div>
			<div className={styles.grid}>
				{['a', 'b', 'c', 'd'].map((k) => (
					<div key={`dep-${k}`} className="h-[180px] animate-pulse rounded-lg bg-grey-25" />
				))}
			</div>
		</main>
	</>
);
